<template>
<div>服务计划与变更</div>
</template>

<script>
export default {
  name: 'changeService'
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/changeService.vue